import PropTypes from 'prop-types'
import MetaTags from 'react-meta-tags';
import React, { useState } from "react"
import { Row, Col, Alert, Card, CardBody, Container, Button } from "reactstrap"
import styled from 'styled-components';

// Redux
import { connect } from "react-redux"
import { withRouter, Link, useHistory } from "react-router-dom"

// availity-reactstrap-validation
import { AvForm, AvField } from "availity-reactstrap-validation"

// action
import { userForgetPassword } from "../../store/actions"

// import images
import loginLogo from "assets/images/login_logo.png"
import weaver from "../../assets/images/weaver.png"
import { postCheckCode, postSendingCode, postSetPassword } from 'crud/auth.crud';

const ForgetPassword = props => {
  const history = useHistory()

  const [findingState, setFindingState] = useState('id')
  const [userId, setUserId] = useState('');
  const [number, setNumber] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [passwd, setPasswd] = useState('');
  const [passwdConfirm, setPasswdConfirm] = useState('');
  const [changePW, setChangePW] = useState(false);
  const [phoneNumberChecked, setPhoneNumberChecked] = useState(false);
  const [numberChecked, setNumberChecked] = useState(false);
  const [idListModal, setIdListModal] = useState(false);

  const [passwordModal, setPasswordModal] = useState(false);
  const [user, setUser] = useState({});
  const [onUpload, setOnUpload] = useState(false);

  const onSendCode = async () => {
    try {
      if (!userId && findingState === 'pw') {
        return alert('아이디를 입력해주세요.')
      }
      if (!phoneNumber) {
        return alert('휴대폰 번호를 입력해주세요.')
      }
      setOnUpload(true)
      let params = {
        phoneNumber: phoneNumber,
      }
      if (findingState === 'pw') {
        params = { ...params, user_id: userId }
      }
      const response = await postSendingCode(params);
      alert(response.data?.msg)
      setOnUpload(false)
      setPhoneNumberChecked(true);

    } catch (e) {
      console.log(e);
    }
  }

  const onCheckCode = async () => {
    try {
      if (!phoneNumberChecked) {
        return alert('인증번호를 확인해주세요.')
      }
      setOnUpload(true)
      let params = {
        phoneNumber: phoneNumber,
        number: number
      }
      if (findingState === 'pw') {
        params = { ...params, user_id: userId }
      }
      const response = await postCheckCode(params);
      if (response.data.result === 'success') {
        setNumberChecked(true);
        if (findingState === 'pw') {
          setChangePW(true)
          setUser(response.data?.data)
          setPasswordModal(true);
        } else {
          setUser(response.data?.data)
          setIdListModal(true);
        }
      }
      setNumber('')
      setOnUpload(false)
      alert(response.data?.msg)
    } catch (e) {
      // console.log(e);
    }
  }

  const onChangePassword = async () => {
    try {
      if (passwd !== passwdConfirm) {
        return alert('비밀번호 확인이 새 비밀번호와 다릅니다.')
      }
      const params = {
        user_id: user.user_id,
        password: passwd
      }
      setOnUpload(true)
      const response = await postSetPassword(params);
      if (response.data?.result === 'success') {
        alert(response.data?.msg)
        setOnUpload(false)
        setPasswordModal(false)
        history.push('login')
      } else {
        setOnUpload(false)
        alert(response.data?.msg)
      }
    } catch (e) {
      alert('비밀번호 변경에 실패하였습니다.')
      console.log(e);
    }
  };

  return (
    <React.Fragment>
      <MetaTags>
        <title>아이디/비밀번호 찾기 | 웨이스트버스</title>
      </MetaTags>
      <div className='col-12 vh-100 position-fixed'>
        <div className="account-pages">
          <Container className='inset-0 membership-box' style={{ height: 466 }}>
            <img src={loginLogo} className='mx-auto d-block mb-5 pointer' onClick={()=>{history.push('/')}} />

            <div className="btn-group mb-4" style={{height: 38}}>
              <Button
                type="button"
                size="sm"
                className={findingState == 'id' ? 'waves-effect custom-btn active' : 'custom-btn waves-effect'}
                onClick={() => {
                  setFindingState('id')
                  setPasswordModal(false)
                }}
              >
                아이디 찾기
              </Button>
              <Button
                type="button"
                size="sm"
                className={findingState == 'pw' ? 'waves-effect custom-btn active' : 'custom-btn waves-effect'}
                onClick={() => {
                  setFindingState('pw')
                  setIdListModal(false)
                  changePW === true && setPasswordModal(true)
                }}
              >
                비밀번호 찾기
              </Button>
            </div>

            <Row className="justify-content-center">
              <Col md={12}>
                <Card className="overflow-hidden">

                  <CardBody className="p-4">

                    <AvForm
                      className="form-horizontal"
                      onValidSubmit={(e, v) => handleValidSubmit(e, v)}
                    >

                      {findingState == 'pw' &&
                        <div className="mb-3" style={{ display: 'flex', justifyContent: 'space-between' }}>
                          <AvField
                            name="id"
                            label="아이디"
                            className="form-control"
                            placeholder="가입 시 사용한 아이디"
                            type="id"
                            required
                            errorMessage="아이디를 입력하세요."
                            onChange={(e) => { setUserId(e.target.value) }}
                          />
                        </div>
                      }
                      <div className="mb-3" style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <AvField
                          name="phoneNumber"
                          label="휴대폰 번호"
                          className="form-control"
                          placeholder="가입 시 사용한 휴대폰 번호"
                          type="text"
                          required
                          errorMessage="휴대폰 번호를 입력하세요."
                          onChange={(e) => { setPhoneNumber(e.target.value); }}
                        />
                        <input type="button" className="btn btn-primary waves-effect waves-light" style={{ height: 35, marginTop: 30, marginLeft: 6 }} onClick={() => { onSendCode() }} value="인증번호 발송" />
                      </div>
                      <div className="mb-3" style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <AvField
                          name="confirmNumber"
                          label="인증번호 입력"
                          className="form-control"
                          placeholder="휴대폰으로 받은 인증번호"
                          type="any"
                          onChange={(e) => { setNumber(e.target.value) }}
                        />
                        <input type="button" className="btn btn-primary waves-effect waves-light" style={{ height: 35, marginTop: 30, marginLeft: 6 }} onClick={() => { onCheckCode() }} value="인증번호 확인" />
                      </div>
                      {/* <Row className="mb-3">
                      <Col className="text-center">
                        <button
                          className="btn btn-warning w-md waves-effect waves-light"
                          type="submit"
                          style={{marginTop: 36, height: 36}}
                          onClick={()=>{onCheckCode()}}
                        >
                          {findingState == 'id' ? '아이디 확인' : '비밀번호 변경'}
                        </button>
                      </Col>
                    </Row> */}
                    </AvForm>
                    {idListModal &&
                      <div className="mb-3" style={{ position: "relative" }}>
                        <p className="noMargin" style={{ fontSize: 16, color: 'black' }}>아이디</p>
                        <input value={user.user_id} className="is-touched is-dirty av-valid form-control" style={{ marginTop: 3, width: 270 }} disabled />
                      </div>
                    }
                    {passwordModal &&
                      <>
                        <div className="mb-3" style={{ position: "relative" }}>
                          <p className="noMargin" style={{ fontSize: 16, color: 'black' }}>패스워드 입력</p>
                          <input type='password' className="is-touched is-dirty av-valid form-control" placeholder='새 비밀번호를 입력하세요.' style={{ marginTop: 3, width: 270 }} onChange={(e) => {
                            setPasswd(e.target.value)
                          }} />
                          <input type='password' className="is-touched is-dirty av-valid form-control" placeholder='비밀번호를 한 번 더 입력하세요.' style={{ marginTop: 6, width: 270 }} onChange={(e) => {
                            setPasswdConfirm(e.target.value)
                          }} />
                        </div>
                        <Row className="mb-3">
                          <Col className="text-center">
                            <button
                              className="btn btn-warning w-md waves-effect waves-light"
                              type="submit"
                              style={{ marginTop: 12, height: 36 }}
                              onClick={() => { onChangePassword() }}
                            >
                              비밀번호 변경하기
                            </button>
                          </Col>
                        </Row>
                      </>
                    }
                  </CardBody>
                </Card>
                <div className="mt-5 text-center text-silver font-size-12">
                  <p>
                    © {new Date().getFullYear()} Wasteverse
                  </p>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      </div>
    </React.Fragment>
  )
}

export default ForgetPassword
